import { j as e } from "./atoms-v218.js";
import { forwardRef as C, useRef as R, useImperativeHandle as V, useLayoutEffect as p } from "react";
import { Rates as P, FirstColumnV1 as L, PictureWrapper as x, V1Picture as d, RateCard as o, PictureColumn as A, FirstColumnV2 as T, PictureWrapperV2 as u, V2Divider as E, AmenitiesContainer as g, AmenitiesTitle as _, AmenitiesList as j, Amenity as h, V2PictureColumn as v, V2Picture as O, PictureColumnV3 as F, V3Picture as f, V3PictureContainer as I, V3LargePicture as $, ContentColumnV3 as b } from "./atoms-v21034.js";
import { useBreakpoints as m } from "./atoms-v251.js";
function y(t) {
  const i = R(0);
  p(() => {
    const r = t.current;
    if (!r)
      return;
    const s = r.querySelector("[data-rate-card]");
    if (!s)
      return;
    const a = () => {
      const c = s.offsetHeight || 0;
      c !== i.current && (i.current = c, r.style.setProperty("--rate-card-h", `${c}px`));
    };
    a();
    const n = new ResizeObserver(a);
    return n.observe(s), () => n.disconnect();
  }, [t]);
}
const H = {
  small: "4/3",
  medium: "16/9",
  large: "1/1",
  xLarge: "1/1",
  max: "1/1"
}, S = ({ pictures: t, rateCard: i }) => {
  const { current: r } = m();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      L,
      {
        bleed: !!["xLarge", "large"].includes(r),
        large: 4,
        max: 5,
        medium: 8,
        offset: { max: 1 },
        small: 4,
        xLarge: 8,
        children: [
          /* @__PURE__ */ e.jsx(x, { $hideOnLarge: !0, children: /* @__PURE__ */ e.jsx(d, { ...t[0], aspectRatio: H[r] }) }),
          /* @__PURE__ */ e.jsx(o, { "data-rate-card": !0, children: i })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(A, { large: 4, max: 9, offset: { max: 1 }, xLarge: 8, children: /* @__PURE__ */ e.jsx(x, { children: /* @__PURE__ */ e.jsx(d, { ...t[0] }) }) })
  ] });
}, U = {
  small: "4/3",
  medium: "16/9",
  large: "1/1",
  xLarge: "2/1",
  max: "2/1"
}, k = ({ amenities: t, amenitiesTitle: i, pictures: r, rateCard: s }) => {
  const { current: a } = m(), n = a === "small" || a === "medium";
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      T,
      {
        bleed: !!["xLarge", "large"].includes(a),
        large: 4,
        max: 5,
        medium: 8,
        offset: { max: 1 },
        small: 4,
        xLarge: 8,
        children: [
          /* @__PURE__ */ e.jsx(u, { $hideOnLarge: !0, children: /* @__PURE__ */ e.jsx(d, { aspectRatio: U[a], ...r[0] }) }),
          /* @__PURE__ */ e.jsx(o, { "data-rate-card": !0, children: s }),
          n && t.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(E, {}),
            /* @__PURE__ */ e.jsxs(g, { children: [
              /* @__PURE__ */ e.jsx(_, { children: i }),
              /* @__PURE__ */ e.jsx(j, { children: t.map((c) => /* @__PURE__ */ e.jsx(h, { children: c }, c)) })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(v, { large: 4, max: 9, offset: { max: 1 }, xLarge: 8, children: [
      /* @__PURE__ */ e.jsx(u, { children: /* @__PURE__ */ e.jsx(O, { ...r[0] }) }),
      !n && t.length > 0 && /* @__PURE__ */ e.jsx(g, { children: /* @__PURE__ */ e.jsx(j, { children: t.map((c) => /* @__PURE__ */ e.jsx(h, { children: c }, c)) }) })
    ] })
  ] });
}, l = {
  small: "4/3",
  medium: "16/9",
  large: "9/16",
  xLarge: "9/16",
  max: "9/16"
}, w = ({ pictures: t, rateCard: i }) => {
  const { current: r } = m(), s = t.slice(0, 2);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(F, { large: 4, max: 9, offset: { max: 1 }, xLarge: 10, children: r === "large" ? /* @__PURE__ */ e.jsx(f, { aspectRatio: l[r], ...t[0] }) : /* @__PURE__ */ e.jsx(I, { children: s.map((a, n) => /* @__PURE__ */ e.jsx(
      $,
      {
        $isFirst: n === 0,
        aspectRatio: l[r],
        ...a
      },
      a.defaultSource
    )) }) }),
    /* @__PURE__ */ e.jsxs(b, { large: 4, max: 5, medium: 8, small: 4, xLarge: 6, children: [
      /* @__PURE__ */ e.jsx(x, { $hideOnLarge: !0, children: /* @__PURE__ */ e.jsx(f, { aspectRatio: l[r], ...t[0] }) }),
      /* @__PURE__ */ e.jsx(o, { "data-rate-card": !0, children: i })
    ] })
  ] });
}, z = C(
  ({ className: t, id: i, variant: r = "v1", ...s }, a) => {
    const n = R(null);
    return V(a, () => n.current), y(n), /* @__PURE__ */ e.jsxs(
      P,
      {
        $variant: r,
        className: t,
        hAlign: "start",
        id: i,
        ref: n,
        tagName: "article",
        vAlign: r === "v3" ? "stretch" : "start",
        children: [
          r === "v1" && /* @__PURE__ */ e.jsx(S, { ...s }),
          r === "v2" && /* @__PURE__ */ e.jsx(k, { ...s }),
          r === "v3" && /* @__PURE__ */ e.jsx(w, { ...s })
        ]
      }
    );
  }
);
z.displayName = "Blocks.Rates";
export {
  z as Rates
};
